import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

import { handleGuidesRedirect } from './utils';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'news-and-guides-details',
		path: '/l/:countryCode/:slug',
		beforeServerRender: handleGuidesRedirect,
		component: loadable(async () => import(/* webpackChunkName: "pages/news_and_guides_details" */ './index'), {
			exportName: 'NewsAndGuidesDetails',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
			config: {
				disallowUserData: true,
				cache: {
					enabled: true,
					lifetimeInSeconds: 60 * 60,
				},
			},
		},
	},
];
